import { render, staticRenderFns } from "./light-map.vue?vue&type=template&id=3eca0511&scoped=true&"
import script from "./light-map.vue?vue&type=script&lang=js&"
export * from "./light-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca0511",
  null
  
)

export default component.exports